import  App from '../../app';

const AMPLITUDE_EVENT_NAME = "Pageview: Analytics";

export default function ReportsController() {

  'ngInject';

  this.$onInit = () => {
    App.amplitude.track(AMPLITUDE_EVENT_NAME);
  }

}